import { defineComponent as D, computed as F, ref as M, onMounted as P, useTemplateRef as z, createElementBlock as u, openBlock as l, Fragment as p, createElementVNode as x, renderList as $, createBlock as g, createCommentVNode as v, unref as d, withCtx as n, createVNode as i, toDisplayString as I, mergeProps as V, createTextVNode as k, normalizeClass as R, capitalize as S } from "vue";
import { DataTableRow as f, DataTableCell as N } from "@scalar/api-client/components/DataTable";
import { useWorkspace as H } from "@scalar/api-client/store";
import { ScalarMarkdownSummary as Q } from "@scalar/components";
import { safeLocalStorage as j, CLIENT_LS_KEYS as B } from "@scalar/helpers/object/local-storage";
import { isDefined as L } from "@scalar/oas-utils/helpers";
import { emitCustomEvent as O } from "@scalar/workspace-store/events";
import { updateScheme as q } from "../helpers/update-scheme.js";
import J from "./OAuth2.vue.js";
import m from "./RequestAuthDataTableInput.vue.js";
const Y = { class: "bg-b-1 text-c-2 outline-b-3 top-0 z-1 h-full w-full overflow-hidden px-3 py-1.25 text-ellipsis group-hover/auth:absolute group-hover/auth:h-auto group-hover/auth:border-b *:first:line-clamp-1 *:first:text-ellipsis group-hover/auth:*:first:line-clamp-none" }, W = {
  key: 0,
  class: "flex min-h-8 border-t text-base"
}, G = { class: "flex h-8 max-w-full gap-2.5 overflow-x-auto px-3" }, X = ["onClick"], Z = { class: "relative z-10" }, de = /* @__PURE__ */ D({
  __name: "RequestAuthTab",
  props: {
    collection: {},
    environment: {},
    envVariables: {},
    layout: {},
    persistAuth: { type: Boolean, default: !1 },
    securitySchemeUids: {},
    server: {},
    workspace: {}
  },
  setup(y) {
    const T = H(), { securitySchemes: U } = T, C = F(
      () => y.securitySchemeUids.map((t) => ({
        scheme: U[t]
      }))
    ), s = M(""), E = (t) => {
      const r = t.description ? `: ${t.description}` : "", e = `${S(t.nameKey)}${r || `: ${t.type}`}`;
      if (t.type === "apiKey")
        return `${S(t.nameKey)}${r || `: ${t.in}`}`;
      if (t.type === "oauth2") {
        const a = Object.values(t.flows ?? {})[0];
        return `${S(t.nameKey)}: ${s.value ? s.value : (a == null ? void 0 : a.type) ?? ""}${r}`;
      }
      return t.type === "http" ? `${S(t.nameKey)}: ${t.scheme}${r}` : `${e}${r}`;
    }, w = (t, r, e) => {
      q(t, r, e, T, _.value, y.persistAuth);
    };
    P(() => {
      if (!y.persistAuth)
        return;
      const t = JSON.parse(
        j().getItem(B.AUTH) ?? "{}"
      ), r = Object.keys(U).reduce(
        (e, a) => {
          const o = U[a];
          return o && (e[o.nameKey] = o.uid), e;
        },
        {}
      );
      Object.entries(t).forEach(([e, a]) => {
        const o = r[e];
        o && Object.entries(a).forEach(([A, K]) => {
          O(_.value, "scalar-edit-security-scheme", {
            uid: o,
            path: A,
            value: K
          });
        });
      });
      try {
        const a = JSON.parse(
          j().getItem(B.SELECTED_SECURITY_SCHEMES) ?? ""
        ).map((o) => Array.isArray(o) ? o.map((b) => r[b]).filter(L) : r[o]).filter(L);
        O(_.value, "scalar-select-security-schemes", {
          uids: a
        });
      } catch {
      }
    });
    const c = {
      environment: y.environment,
      envVariables: y.envVariables,
      workspace: y.workspace
    }, _ = z("wrapperRef");
    return (t, r) => (l(), u(p, null, [
      x("div", {
        ref_key: "wrapperRef",
        ref: _
      }, null, 512),
      (l(!0), u(p, null, $(C.value, ({ scheme: e }) => (l(), u(p, {
        key: e == null ? void 0 : e.uid
      }, [
        C.value.length > 1 && e ? (l(), g(d(f), { key: 0 }, {
          default: n(() => [
            i(d(N), {
              "aria-label": E(e),
              class: "text-c-2 group/auth flex items-center leading-[22px] whitespace-nowrap outline-none hover:whitespace-normal"
            }, {
              default: n(() => [
                x("p", Y, I(E(e)), 1)
              ]),
              _: 2
            }, 1032, ["aria-label"])
          ]),
          _: 2
        }, 1024)) : v("", !0),
        e != null && e.description && C.value.length <= 1 ? (l(), g(d(f), { key: 1 }, {
          default: n(() => [
            i(d(N), {
              "aria-label": e.description,
              class: "max-h-[auto]"
            }, {
              default: n(() => [
                i(d(Q), {
                  class: "auth-description bg-b-1 text-c-2 min-w-0 flex-1 px-3 py-1.25",
                  value: e.description
                }, null, 8, ["value"])
              ]),
              _: 2
            }, 1032, ["aria-label"])
          ]),
          _: 2
        }, 1024)) : v("", !0),
        (e == null ? void 0 : e.type) === "http" ? (l(), u(p, { key: 2 }, [
          e.scheme === "bearer" ? (l(), g(d(f), { key: 0 }, {
            default: n(() => [
              i(m, V({ ref_for: !0 }, c, {
                containerClass: t.layout === "reference" && "border-t",
                modelValue: e.token,
                placeholder: "Token",
                type: "password",
                "onUpdate:modelValue": (a) => w(e.uid, "token", a)
              }), {
                default: n(() => r[0] || (r[0] = [
                  k(" Bearer Token ")
                ])),
                _: 2,
                __: [0]
              }, 1040, ["containerClass", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)) : (e == null ? void 0 : e.scheme) === "basic" ? (l(), u(p, { key: 1 }, [
            i(d(f), null, {
              default: n(() => [
                i(m, V({ ref_for: !0 }, c, {
                  class: "text-c-2",
                  modelValue: e.username,
                  placeholder: "janedoe",
                  required: "",
                  "onUpdate:modelValue": (a) => w(e.uid, "username", a)
                }), {
                  default: n(() => r[1] || (r[1] = [
                    k(" Username ")
                  ])),
                  _: 2,
                  __: [1]
                }, 1040, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024),
            i(d(f), null, {
              default: n(() => [
                i(m, V({ ref_for: !0 }, c, {
                  modelValue: e.password,
                  placeholder: "********",
                  type: "password",
                  "onUpdate:modelValue": (a) => w(e.uid, "password", a)
                }), {
                  default: n(() => r[2] || (r[2] = [
                    k(" Password ")
                  ])),
                  _: 2,
                  __: [2]
                }, 1040, ["modelValue", "onUpdate:modelValue"])
              ]),
              _: 2
            }, 1024)
          ], 64)) : v("", !0)
        ], 64)) : (e == null ? void 0 : e.type) === "apiKey" ? (l(), u(p, { key: 3 }, [
          i(d(f), null, {
            default: n(() => [
              i(m, V({ ref_for: !0 }, c, {
                containerClass: t.layout === "reference" && "border-t",
                modelValue: e.name,
                placeholder: "api-key",
                "onUpdate:modelValue": (a) => w(e.uid, "name", a)
              }), {
                default: n(() => r[3] || (r[3] = [
                  k(" Name ")
                ])),
                _: 2,
                __: [3]
              }, 1040, ["containerClass", "modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024),
          i(d(f), null, {
            default: n(() => [
              i(m, V({ ref_for: !0 }, c, {
                modelValue: e.value,
                placeholder: "QUxMIFlPVVIgQkFTRSBBUkUgQkVMT05HIFRPIFVT",
                type: "password",
                "onUpdate:modelValue": (a) => w(e.uid, "value", a)
              }), {
                default: n(() => r[4] || (r[4] = [
                  k(" Value ")
                ])),
                _: 2,
                __: [4]
              }, 1040, ["modelValue", "onUpdate:modelValue"])
            ]),
            _: 2
          }, 1024)
        ], 64)) : (e == null ? void 0 : e.type) === "oauth2" ? (l(), u(p, { key: 4 }, [
          i(d(f), null, {
            default: n(() => [
              Object.keys(e.flows).length > 1 ? (l(), u("div", W, [
                x("div", G, [
                  (l(!0), u(p, null, $(e == null ? void 0 : e.flows, (a, o, b) => (l(), u("button", {
                    key: o,
                    class: R(["floating-bg text-c-3 relative cursor-pointer border-b-[1px] border-transparent py-1 text-base font-medium", {
                      "!text-c-1 !rounded-none border-b-[1px] !border-current": t.layout !== "reference" && (s.value === o || b === 0 && !s.value),
                      "!text-c-1 !rounded-none border-b-[1px] !border-current opacity-100": t.layout === "reference" && (s.value === o || b === 0 && !s.value)
                    }]),
                    type: "button",
                    onClick: (A) => s.value = o
                  }, [
                    x("span", Z, I(o), 1)
                  ], 10, X))), 128))
                ])
              ])) : v("", !0)
            ]),
            _: 2
          }, 1024),
          (l(!0), u(p, null, $(e == null ? void 0 : e.flows, (a, o, b) => (l(), u(p, { key: o }, [
            s.value === o || b === 0 && !s.value ? (l(), g(J, V({
              key: 0,
              ref_for: !0
            }, c, {
              collection: t.collection,
              flow: a,
              persistAuth: t.persistAuth,
              scheme: e,
              server: t.server,
              workspace: t.workspace
            }), null, 16, ["collection", "flow", "persistAuth", "scheme", "server", "workspace"])) : v("", !0)
          ], 64))), 128))
        ], 64)) : (e == null ? void 0 : e.type) === "openIdConnect" ? (l(), u("div", {
          key: 5,
          class: R(["text-c-3 bg-b-1 flex min-h-[calc(4rem+1px)] items-center justify-center border-t border-b-0 px-4 text-base", { "rounded-b-lg": t.layout === "reference" }])
        }, " Coming soon ", 2)) : v("", !0)
      ], 64))), 128))
    ], 64));
  }
});
export {
  de as default
};
